var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingdegruposaseguradores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1800 200.843",
    width: 1800,
    height: 200.843,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    transform: "translate(-152,-429.79715)",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_219",
    "data-name": "Trazado 219",
    d: "m 159.12,431.6 h 27.16 c 14.36,0 26.45,5 26.45,21.31 0,9.81 -5.25,17.44 -15.16,19.23 l 17.84,29.61 h -18.54 l -14.67,-28 h -7.63 v 28 h -15.45 z m 15.45,29 h 9.12 c 5.65,0 13,-0.2 13,-7.83 0,-7 -6.35,-8.12 -12,-8.12 h -10.1 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    d: "m 244,431.6 h 12.79 l 30.52,70.17 h -17.48 l -6,-14.87 h -27.3 l -5.84,14.87 h -17.05 z m 5.91,20.4 -8.52,21.8 h 17.14 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "m 291.83,431.6 h 21 l 29.83,48.76 h 0.2 V 431.6 h 15.45 v 70.17 h -20.2 l -30.62,-49.95 h -0.2 v 49.95 h -15.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "m 370.71,431.6 h 15.46 v 29.14 l 27.27,-29.14 h 20.21 l -31.21,32.61 33.89,37.56 h -21.6 l -28.55,-33.3 v 33.3 h -15.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_223",
    "data-name": "Trazado 223",
    d: "m 439,431.6 h 15.45 v 70.17 H 439 Z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_224",
    "data-name": "Trazado 224",
    d: "m 466.05,431.6 h 21 l 29.82,48.76 h 0.2 V 431.6 h 15.46 v 70.17 H 512.32 L 481.7,451.82 h -0.2 v 49.95 h -15.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_225",
    "data-name": "Trazado 225",
    d: "m 607.86,496.81 a 62.9,62.9 0 0 1 -29.43,6.74 c -21.9,0 -37.86,-14.37 -37.86,-36.86 0,-22.49 16,-36.87 37.86,-36.87 11.1,0 20.91,2.48 27.94,9 l -10.9,11.9 a 21.55,21.55 0 0 0 -17,-6.64 c -13.18,0 -21.8,9.51 -21.8,22.59 0,13.08 8.62,22.6 21.8,22.6 A 30.29,30.29 0 0 0 593,485.81 v -11.39 h -12.59 v -14.27 h 27.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    d: "M 645.81,431.6 H 669 c 22.59,0 41.52,9.62 41.52,35.29 0,22.69 -18.54,34.88 -39.44,34.88 h -25.27 z m 15.45,55.89 h 8 c 14.37,0 25.17,-5.45 25.17,-21.4 0,-13.78 -11,-20.22 -24.08,-20.22 h -9.12 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    d: "m 719.15,431.6 h 47.67 v 14.28 H 734.61 V 459 H 765 v 14.27 h -30.39 v 14.23 h 34 v 14.27 h -49.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_228",
    "data-name": "Trazado 228",
    d: "m 868.89,496.81 a 63,63 0 0 1 -29.43,6.74 c -21.89,0 -37.86,-14.37 -37.86,-36.86 0,-22.49 15.95,-36.87 37.86,-36.87 11.1,0 20.91,2.48 27.95,9 l -10.91,11.9 a 21.52,21.52 0 0 0 -17,-6.64 c -13.18,0 -21.8,9.51 -21.8,22.59 0,13.08 8.62,22.6 21.8,22.6 a 30.29,30.29 0 0 0 14.5,-3.46 v -11.39 h -12.56 v -14.27 h 27.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    d: "m 880,431.6 h 27.15 c 14.37,0 26.46,5 26.46,21.31 0,9.81 -5.25,17.44 -15.16,19.23 l 17.84,29.61 h -18.53 l -14.68,-28 h -7.63 v 28 H 880 Z m 15.45,29 h 9.12 c 5.65,0 13,-0.2 13,-7.83 0,-7 -6.34,-8.12 -12,-8.12 h -10.12 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    d: "m 1000.89,474.71 c 0,16.55 -10.1,28.85 -29.53,28.85 -19.43,0 -29.62,-12.29 -29.62,-28.85 V 431.6 h 15.46 v 42.52 a 14.29,14.29 0 0 0 13.4,15.13 c 0.25,0 0.51,0 0.76,0 8.13,0 14.08,-6.54 14.08,-15.16 V 431.6 h 15.45 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    d: "m 1012.69,431.6 h 26.06 c 14.57,0 26.66,4.66 26.66,21.31 0,16.45 -11.2,21.51 -26,21.51 h -11.29 v 27.35 h -15.46 z m 15.45,29.73 h 10.3 c 5.45,0 10.9,-1.88 10.9,-8.42 0,-7.23 -7.33,-8.22 -13.28,-8.22 h -7.92 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    d: "m 1106.73,429.82 c 21.89,0 37.86,14.37 37.86,36.87 0,22.5 -16,36.86 -37.86,36.86 -21.86,0 -37.86,-14.37 -37.86,-36.86 0,-22.49 15.96,-36.87 37.86,-36.87 z m 0,59.46 c 13.18,0 21.8,-9.52 21.8,-22.6 0,-13.08 -8.62,-22.59 -21.8,-22.59 -13.18,0 -21.8,9.51 -21.8,22.59 0,13.08 8.62,22.6 21.8,22.6 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233",
    "data-name": "Trazado 233",
    d: "m 1187.3,448.75 a 14.94,14.94 0 0 0 -11.2,-4.66 c -4.36,0 -10.4,2 -10.4,7.24 0,12.78 32.3,4.55 32.3,29.13 0,15.66 -12.59,23.09 -27,23.09 a 33.33,33.33 0 0 1 -23.59,-8.82 l 11,-12.09 a 17.2,17.2 0 0 0 13.48,6.64 c 5.05,0 10.7,-2.38 10.7,-7.33 0,-12.88 -32.9,-5.95 -32.9,-29.34 0,-15 13,-22.79 26.76,-22.79 a 31.69,31.69 0 0 1 21.5,7.33 z",
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_430",
    "data-name": "Rect\\xE1ngulo 430",
    x: 151.72392,
    y: 627.2583,
    width: 68.209999,
    height: 3.2,
    style: {
      fill: "#f4f4f4",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "ASEGURADORES Y REASEGURADORES",
    id: "text346",
    style: {
      fontSize: 96,
      lineHeight: 1,
      letterSpacing: "-1px",
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 168.6488,572.19252 h 35.136 l 7.488,17.856 h 7.68 l -29.184,-67.968 h -6.72 l -29.376,67.968 h 7.584 z m 17.568,-42.432 14.976,36.096 h -29.952 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 266.33687,528.60852 c -3.264,-4.416 -10.08,-8.256 -19.2,-8.256 -9.984,0 -21.696,5.568 -21.696,18.72 0,12.288 9.216,16.224 18.24,19.008 8.64,2.688 16.608,5.088 16.608,14.592 0,8.736 -8.064,13.152 -15.072,13.152 -7.104,0 -12.576,-3.744 -15.552,-8.544 l -5.952,4.416 c 4.896,6.72 13.152,10.08 21.408,10.08 10.752,0 22.176,-5.952 22.176,-19.584 0,-13.632 -10.56,-16.704 -20.16,-19.872 -7.584,-2.496 -14.784,-4.704 -14.784,-13.344 0,-8.736 7.776,-12.768 14.496,-12.768 6.432,0 11.136,2.688 14.016,6.816 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 287.99279,557.69652 h 32.928 v -6.048 h -32.928 v -23.424 h 35.232 v -6.144 h -42.144 v 67.968 h 43.296 v -6.144 h -36.384 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 393.26489,529.47252 c -5.76,-5.664 -13.824,-9.12 -24.576,-9.12 -20.256,0 -35.424,15.072 -35.424,35.712 0,20.64 14.88,35.712 35.424,35.712 9.216,0 17.952,-2.208 25.344,-6.624 v -30.624 h -22.752 v 6.048 h 15.84 v 20.64 c -3.936,2.592 -10.656,4.416 -18.336,4.416 -17.472,0 -28.224,-13.728 -28.224,-29.568 0,-15.84 10.752,-29.664 28.224,-29.664 8.448,0 14.976,2.88 19.68,7.872 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 435.75282,591.77652 c 20.352,0 25.44,-15.744 25.44,-27.072 v -42.624 h -6.912 v 41.856 c 0,10.944 -4.704,21.696 -18.528,21.696 -13.824,0 -18.528,-10.752 -18.528,-21.696 v -41.856 h -6.912 v 42.624 c 0,11.328 5.088,27.072 25.44,27.072 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 484.76873,558.27252 h 11.52 l 18.816,31.776 h 8.448 l -19.872,-32.352 c 9.888,-1.056 17.376,-7.392 17.376,-17.472 0,-13.248 -9.792,-18.144 -23.232,-18.144 h -19.968 v 67.968 h 6.912 z m 0,-30.24 h 12.288 c 10.272,0 17.088,3.264 17.088,12.192 0,8.064 -6.336,12.096 -17.376,12.096 h -12 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 541.27282,572.19252 h 35.136 l 7.488,17.856 h 7.68 l -29.184,-67.968 h -6.72 l -29.376,67.968 h 7.584 z m 17.568,-42.432 14.976,36.096 h -29.952 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 600.5609,590.04852 h 22.56 c 16.992,0 35.712,-11.328 35.712,-33.984 0,-22.656 -18.72,-33.984 -35.712,-33.984 h -22.56 z m 6.912,-61.824 h 13.728 c 20.448,0 30.336,13.824 30.336,27.84 0,14.016 -9.888,27.84 -30.336,27.84 h -13.728 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 739.43289,556.06452 c 0,-20.64 -15.168,-35.712 -35.424,-35.712 -20.256,0 -35.424,15.072 -35.424,35.712 0,20.64 15.168,35.712 35.424,35.712 20.256,0 35.424,-15.072 35.424,-35.712 z m -7.296,0 c 0,15.84 -10.656,29.568 -28.128,29.568 -17.472,0 -28.128,-13.728 -28.128,-29.568 0,-15.84 10.656,-29.664 28.128,-29.664 17.472,0 28.128,13.824 28.128,29.664 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 759.74493,558.27252 h 11.52 l 18.816,31.776 h 8.448 l -19.872,-32.352 c 9.888,-1.056 17.376,-7.392 17.376,-17.472 0,-13.248 -9.792,-18.144 -23.232,-18.144 h -19.968 v 67.968 h 6.912 z m 0,-30.24 h 12.288 c 10.272,0 17.088,3.264 17.088,12.192 0,8.064 -6.336,12.096 -17.376,12.096 h -12 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 816.24902,557.69652 h 32.928 v -6.048 h -32.928 v -23.424 h 35.232 v -6.144 h -42.144 v 67.968 h 43.296 v -6.144 h -36.384 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 903.56911,528.60852 c -3.264,-4.416 -10.08,-8.256 -19.2,-8.256 -9.984,0 -21.696,5.568 -21.696,18.72 0,12.288 9.216,16.224 18.24,19.008 8.64,2.688 16.608,5.088 16.608,14.592 0,8.736 -8.064,13.152 -15.072,13.152 -7.104,0 -12.576,-3.744 -15.552,-8.544 l -5.952,4.416 c 4.896,6.72 13.152,10.08 21.408,10.08 10.752,0 22.176,-5.952 22.176,-19.584 0,-13.632 -10.56,-16.704 -20.16,-19.872 -7.584,-2.496 -14.784,-4.704 -14.784,-13.344 0,-8.736 7.776,-12.768 14.496,-12.768 6.432,0 11.136,2.688 14.016,6.816 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 962.33702,560.76852 25.44,-38.688 h -8.064 l -20.64,32.928 -20.448,-32.928 h -8.64 l 25.44,38.688 v 29.28 h 6.912 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1023.4089,558.27252 h 11.52 l 18.816,31.776 h 8.448 l -19.872,-32.352 c 9.888,-1.056 17.376,-7.392 17.376,-17.472 0,-13.248 -9.792,-18.144 -23.232,-18.144 h -19.968 v 67.968 h 6.912 z m 0,-30.24 h 12.288 c 10.272,0 17.088,3.264 17.088,12.192 0,8.064 -6.336,12.096 -17.376,12.096 h -12 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1079.913,557.69652 h 32.928 v -6.048 h -32.928 v -23.424 h 35.232 v -6.144 h -42.144 v 67.968 h 43.296 v -6.144 h -36.384 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1135.7451,572.19252 h 35.136 l 7.488,17.856 h 7.68 l -29.184,-67.968 h -6.72 l -29.376,67.968 h 7.584 z m 17.568,-42.432 14.976,36.096 h -29.952 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1233.4332,528.60852 c -3.264,-4.416 -10.08,-8.256 -19.2,-8.256 -9.984,0 -21.696,5.568 -21.696,18.72 0,12.288 9.216,16.224 18.24,19.008 8.64,2.688 16.608,5.088 16.608,14.592 0,8.736 -8.064,13.152 -15.072,13.152 -7.104,0 -12.576,-3.744 -15.552,-8.544 l -5.952,4.416 c 4.896,6.72 13.152,10.08 21.408,10.08 10.752,0 22.176,-5.952 22.176,-19.584 0,-13.632 -10.56,-16.704 -20.16,-19.872 -7.584,-2.496 -14.784,-4.704 -14.784,-13.344 0,-8.736 7.776,-12.768 14.496,-12.768 6.432,0 11.136,2.688 14.016,6.816 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1255.0891,557.69652 h 32.928 v -6.048 h -32.928 v -23.424 h 35.232 v -6.144 h -42.144 v 67.968 h 43.296 v -6.144 h -36.384 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1360.3613,529.47252 c -5.76,-5.664 -13.824,-9.12 -24.576,-9.12 -20.256,0 -35.424,15.072 -35.424,35.712 0,20.64 14.88,35.712 35.424,35.712 9.216,0 17.952,-2.208 25.344,-6.624 v -30.624 h -22.752 v 6.048 h 15.84 v 20.64 c -3.936,2.592 -10.656,4.416 -18.336,4.416 -17.472,0 -28.224,-13.728 -28.224,-29.568 0,-15.84 10.752,-29.664 28.224,-29.664 8.448,0 14.976,2.88 19.68,7.872 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1402.8492,591.77652 c 20.352,0 25.44,-15.744 25.44,-27.072 v -42.624 h -6.912 v 41.856 c 0,10.944 -4.704,21.696 -18.528,21.696 -13.824,0 -18.528,-10.752 -18.528,-21.696 v -41.856 h -6.912 v 42.624 c 0,11.328 5.088,27.072 25.44,27.072 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1451.8651,558.27252 h 11.52 l 18.816,31.776 h 8.448 l -19.872,-32.352 c 9.888,-1.056 17.376,-7.392 17.376,-17.472 0,-13.248 -9.792,-18.144 -23.232,-18.144 h -19.968 v 67.968 h 6.912 z m 0,-30.24 h 12.288 c 10.272,0 17.088,3.264 17.088,12.192 0,8.064 -6.336,12.096 -17.376,12.096 h -12 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1508.3691,572.19252 h 35.136 l 7.488,17.856 h 7.68 l -29.184,-67.968 h -6.72 l -29.376,67.968 h 7.584 z m 17.568,-42.432 14.976,36.096 h -29.952 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1567.6572,590.04852 h 22.56 c 16.992,0 35.712,-11.328 35.712,-33.984 0,-22.656 -18.72,-33.984 -35.712,-33.984 h -22.56 z m 6.912,-61.824 h 13.728 c 20.448,0 30.336,13.824 30.336,27.84 0,14.016 -9.888,27.84 -30.336,27.84 h -13.728 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1706.5292,556.06452 c 0,-20.64 -15.168,-35.712 -35.424,-35.712 -20.256,0 -35.424,15.072 -35.424,35.712 0,20.64 15.168,35.712 35.424,35.712 20.256,0 35.424,-15.072 35.424,-35.712 z m -7.296,0 c 0,15.84 -10.656,29.568 -28.128,29.568 -17.472,0 -28.128,-13.728 -28.128,-29.568 0,-15.84 10.656,-29.664 28.128,-29.664 17.472,0 28.128,13.824 28.128,29.664 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1726.8412,558.27252 h 11.52 l 18.816,31.776 h 8.448 l -19.872,-32.352 c 9.888,-1.056 17.376,-7.392 17.376,-17.472 0,-13.248 -9.792,-18.144 -23.232,-18.144 h -19.968 v 67.968 h 6.912 z m 0,-30.24 h 12.288 c 10.272,0 17.088,3.264 17.088,12.192 0,8.064 -6.336,12.096 -17.376,12.096 h -12 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1783.3453,557.69652 h 32.928 v -6.048 h -32.928 v -23.424 h 35.232 v -6.144 h -42.144 v 67.968 h 43.296 v -6.144 h -36.384 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1870.6654,528.60852 c -3.264,-4.416 -10.08,-8.256 -19.2,-8.256 -9.984,0 -21.696,5.568 -21.696,18.72 0,12.288 9.216,16.224 18.24,19.008 8.64,2.688 16.608,5.088 16.608,14.592 0,8.736 -8.064,13.152 -15.072,13.152 -7.104,0 -12.576,-3.744 -15.552,-8.544 l -5.952,4.416 c 4.896,6.72 13.152,10.08 21.408,10.08 10.752,0 22.176,-5.952 22.176,-19.584 0,-13.632 -10.56,-16.704 -20.16,-19.872 -7.584,-2.496 -14.784,-4.704 -14.784,-13.344 0,-8.736 7.776,-12.768 14.496,-12.768 6.432,0 11.136,2.688 14.016,6.816 z",
    style: {
      fontFamily: "'Avenir Next LT Pro'",
      InkscapeFontSpecification: "'Avenir Next LT Pro'",
      fill: "#ffffff"
    },
    id: "path597"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingdegruposaseguradores);
export default __webpack_public_path__ + "static/media/ranking de grupos aseguradores.f39102143ee0746eeb4510a27526f361.svg";
export { ForwardRef as ReactComponent };